export default function LikeOrLikes(c) {
    if (c > 1) {
        return 'Likes'
    } else {
        return 'Like'
    }
}